import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { HelpFeedbackComponent } from '../help-feedback.component';
import { AuthService } from 'src/app/services/user/auth.service';

@Component({
    selector: 'guest-help-feedback-desktop',
    templateUrl: './help-feedback-desktop.component.html',
    styleUrls: ['./help-feedback-desktop.component.scss'],
    standalone: false
})
export class HelpFeedbackDesktopComponent extends HelpFeedbackComponent implements OnInit {

  constructor(
    protected deviceService: DeviceDetectorService,
    protected authService: AuthService,
  ) {
    super(deviceService, authService);
  }

  ngOnInit(): void {
  }

}
